<script setup>
import { WarningAlert } from '@codinglabsau/ui'
import ReputationModal from './ReputationModal.vue'
</script>

<template>
  <WarningAlert v-if="$page.props.auth.user?.level === 0" class="mb-4">
    <div class="flex items-center gap-2 text-sm">
      Further moderation is required until you attain the Ticket of Leave rank.
      <ReputationModal />
    </div>
  </WarningAlert>
</template>
